import Select from '@admin/components/form/select'
import PropTypes from 'prop-types'
import React from 'react'

const RadioGroup = React.forwardRef((props, ref) => {
  return <Select { ...props } ref={ ref } multiple={ false } selectFirst={ props.selectFirst !== false } />
})

RadioGroup.propTypes = {
  selectFirst: PropTypes.bool
}

export default RadioGroup